import React, {memo, useState, useRef} from "../../../__snowpack__/pkg/react.js";
import {Tooltip} from "../../../__snowpack__/pkg/antd.js";
import styled from "../../../__snowpack__/pkg/styled-components.js";
export const EllipsisTooltip = memo((props) => {
  const {title} = props;
  const [Visible, setVisible] = useState(false);
  const containerRef = useRef(null);
  const handleVisibleChange = (visible) => {
    if (containerRef.current.clientWidth < containerRef.current.scrollWidth) {
      setVisible(visible);
    }
  };
  return /* @__PURE__ */ React.createElement(Tooltip, {
    visible: Visible,
    onVisibleChange: handleVisibleChange,
    title
  }, /* @__PURE__ */ React.createElement(ProductNameWrapper, null, /* @__PURE__ */ React.createElement("div", {
    ref: containerRef,
    className: "product-name",
    style: {
      fontSize: 12,
      fontFamily: "SFProText-Regular",
      fontWeight: 400,
      color: "#202D40"
    }
  }, title)));
});
const ProductNameWrapper = styled.div`
  .product-name {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
  }
`;
